import { render } from "./OrdersPending.vue?vue&type=template&id=3c65e3f9&scoped=true"
import script from "./OrdersPending.vue?vue&type=script&lang=js"
export * from "./OrdersPending.vue?vue&type=script&lang=js"

import "./OrdersPending.vue?vue&type=style&index=0&id=3c65e3f9&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c65e3f9"]])

export default __exports__